/**
 * Configurazione centralizzata degli endpoint API
 * 
 * In sviluppo: usa URL diretto API Gateway (proxy in package.json gestisce CORS)
 * In produzione: usa URL assoluti di API Gateway configurati via .env
 */

// Base URL per le API di autenticazione e utente
export const AUTH_API_BASE_URL = process.env.REACT_APP_AUTH_API_URL || 'https://22y9g9yki2.execute-api.eu-central-1.amazonaws.com/prod';

// Base URL per tutte le API (autenticazione, documenti, attività, materiali)
// Tutto su API Gateway 22y9g9yki2 (mamadoc-api PROD)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://22y9g9yki2.execute-api.eu-central-1.amazonaws.com/prod';

console.log('🔧 API CONFIG:');
console.log('  - AUTH_API_BASE_URL:', AUTH_API_BASE_URL);
console.log('  - API_BASE_URL:', API_BASE_URL);
